// extracted by mini-css-extract-plugin
module.exports = {"page":"AboutUs_page__29zhh","content":"AboutUs_content__3uLx5"};